import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentMode, selectCurrentMode, selectIsLawyer } from '../slices/authSlice';

// Hook para el modo de autenticación (cliente/abogado)
export const useAuthMode = () => {
  const dispatch = useDispatch();
  const currentMode = useSelector(selectCurrentMode);
  const isLawyer = useSelector(selectIsLawyer);

  const setMode = useCallback(mode => dispatch(setCurrentMode(mode)), [dispatch]);

  const toggleMode = useCallback(
    () => dispatch(setCurrentMode(isLawyer ? 'client' : 'lawyer')),
    [dispatch, isLawyer]
  );

  return {
    currentMode,
    isLawyer,
    isClient: !isLawyer,
    setMode,
    toggleMode,
    setClientMode: () => setMode('client'),
    setLawyerMode: () => setMode('lawyer'),
  };
};
